module.exports = __webpack_public_path__ + "img/jackpots_select.00ac9f4a.svg";